var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 152,
    rx: 10,
    fill: "#00CA9A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5889 88.5322C82.7374 88.5322 88.5323 82.7372 88.5323 75.5888C88.5323 68.4403 82.7374 62.6454 75.5889 62.6454C68.4405 62.6454 62.6455 68.4403 62.6455 75.5888C62.6455 82.7372 68.4405 88.5322 75.5889 88.5322Z",
    fill: "url(#paint0_radial_30_2510)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.855 70.3833C116.693 69.0868 115.735 68.0303 114.467 67.7155L106.047 65.6252C105.535 64.0593 104.907 62.5462 104.171 61.0969L108.647 53.6649C109.321 52.5456 109.251 51.1212 108.449 50.0897C107.394 48.7334 106.243 47.4274 104.996 46.1808C103.75 44.9342 102.444 43.7833 101.088 42.7283C100.056 41.926 98.6319 41.8564 97.5124 42.5306L90.0804 47.0064C88.6311 46.2701 87.118 45.6421 85.5521 45.1303L83.4619 36.7107C83.147 35.4427 82.0907 34.4844 80.794 34.3225C79.0887 34.1097 77.3515 34 75.5886 34C73.8258 34 72.0886 34.1097 70.3833 34.3225C69.0868 34.4844 68.0303 35.4424 67.7155 36.7107L65.6252 45.1303C64.0593 45.6423 62.5462 46.2701 61.0969 47.0064L53.6649 42.5306C52.5456 41.8564 51.1212 41.926 50.0897 42.7283C48.7334 43.7835 47.4274 44.9344 46.1808 46.1808C44.9342 47.4274 43.7833 48.7334 42.7283 50.0897C41.926 51.1209 41.8564 52.5454 42.5306 53.6649L47.0064 61.0969C46.2701 62.5462 45.6421 64.0593 45.1303 65.6252L36.7107 67.7155C35.4427 68.0303 34.4844 69.0866 34.3225 70.3833C34.1097 72.0886 34 73.8258 34 75.5886C34 77.3515 34.1097 79.0887 34.3225 80.794C34.4844 82.0905 35.4424 83.147 36.7107 83.4619L45.1303 85.5521C45.6423 87.118 46.2701 88.6311 47.0064 90.0804L42.5306 97.5124C41.8564 98.6317 41.926 100.056 42.7283 101.088C43.7835 102.444 44.9344 103.75 46.1808 104.996C47.4274 106.243 48.7334 107.394 50.0897 108.449C51.1209 109.251 52.5454 109.321 53.6649 108.647L61.0969 104.171C62.5462 104.907 64.0593 105.535 65.6252 106.047L67.7155 114.467C68.0303 115.735 69.0866 116.693 70.3833 116.855C72.0884 117.068 73.8258 117.177 75.5886 117.177C77.3515 117.177 79.0887 117.068 80.794 116.855C82.0905 116.693 83.147 115.735 83.4619 114.467L85.5521 106.047C87.118 105.535 88.6311 104.907 90.0804 104.171L97.5124 108.647C98.6317 109.321 100.056 109.251 101.088 108.449C102.444 107.394 103.75 106.243 104.996 104.996C106.243 103.75 107.394 102.444 108.449 101.088C109.251 100.056 109.321 98.6319 108.647 97.5124L104.171 90.0804C104.907 88.6311 105.535 87.118 106.047 85.5521L114.467 83.4619C115.735 83.147 116.693 82.0907 116.855 80.794C117.068 79.0889 117.177 77.3515 117.177 75.5886C117.177 73.8258 117.068 72.0886 116.855 70.3833ZM75.5886 88.5321C68.4403 88.5321 62.6452 82.737 62.6452 75.5886C62.6452 68.4403 68.4403 62.6452 75.5886 62.6452C82.737 62.6452 88.5321 68.4403 88.5321 75.5886C88.5321 82.737 82.737 88.5321 75.5886 88.5321Z",
    fill: "url(#paint1_linear_30_2510)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5886 43.5485C57.8932 43.5485 43.5483 57.8934 43.5483 75.5887C43.5483 93.284 57.8932 107.629 75.5886 107.629C93.2839 107.629 107.629 93.284 107.629 75.5887C107.629 57.8934 93.2839 43.5485 75.5886 43.5485ZM75.5886 88.5321C68.4402 88.5321 62.6452 82.7371 62.6452 75.5887C62.6452 68.4403 68.4402 62.6453 75.5886 62.6453C82.7369 62.6453 88.532 68.4403 88.532 75.5887C88.532 82.7371 82.7369 88.5321 75.5886 88.5321Z",
    fill: "url(#paint2_linear_30_2510)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.588 49.9139C61.4083 49.9139 49.9133 61.409 49.9133 75.5886C49.9133 89.7682 61.4083 101.263 75.588 101.263C89.7676 101.263 101.263 89.7682 101.263 75.5886C101.263 61.409 89.7676 49.9139 75.588 49.9139ZM75.588 88.532C68.4396 88.532 62.6445 82.7369 62.6445 75.5886C62.6445 68.4402 68.4396 62.6452 75.588 62.6452C82.7363 62.6452 88.5314 68.4402 88.5314 75.5886C88.5314 82.7369 82.7363 88.532 75.588 88.532Z",
    fill: "url(#paint3_linear_30_2510)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5873 56.2794C64.9232 56.2794 56.2783 64.9243 56.2783 75.5884C56.2783 86.2525 64.9232 94.8974 75.5873 94.8974C86.2514 94.8974 94.8964 86.2525 94.8964 75.5884C94.8964 64.9243 86.2514 56.2794 75.5873 56.2794ZM75.5873 83.5454C71.1927 83.5454 67.6303 79.983 67.6303 75.5884C67.6303 71.1938 71.1927 67.6314 75.5873 67.6314C79.9819 67.6314 83.5443 71.1938 83.5443 75.5884C83.5443 79.983 79.9819 83.5454 75.5873 83.5454Z",
    fill: "url(#paint4_linear_30_2510)",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7701 88.5321C68.106 88.5321 59.4611 79.8872 59.4611 69.2231C59.4611 67.3875 59.7174 65.6117 60.1959 63.9294C57.7377 67.1693 56.2783 71.2083 56.2783 75.5887C56.2783 86.2528 64.9232 94.8977 75.5873 94.8977C84.4158 94.8977 91.8602 88.9728 94.1615 80.8823C90.6356 85.5299 85.0538 88.5321 78.7701 88.5321Z",
    fill: "url(#paint5_linear_30_2510)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_30_2510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.5889 75.4827) scale(27.7555)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_2510",
    x1: 2.9371,
    y1: 148.24,
    x2: 124.771,
    y2: 26.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30_2510",
    x1: 15.6776,
    y1: 135.5,
    x2: 134.936,
    y2: 16.2411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9085,
    stopColor: "white",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_30_2510",
    x1: 56.0668,
    y1: 97.1255,
    x2: 115.15,
    y2: 36.0267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_30_2510",
    x1: 40.2283,
    y1: 110.947,
    x2: 87.9971,
    y2: 63.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8198,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_30_2510",
    x1: 50.4035,
    y1: 100.901,
    x2: 85.9039,
    y2: 65.4003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.026,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a3539fc243d18765108fdafec819e1d5.svg";
export { ForwardRef as ReactComponent };